import uuid from 'powtoon-commons/utils/uuid'
import {isCharacterItem, isFyberItem} from 'powtoon-document'

import {ENTER_EFFECT_IDS, EXIT_EFFECT_IDS} from 'powtoon-document/consts'

import lib2docItem from '../lib2docItem'

//TODO: default endtime = null. no endtime = the track leasts until the end of the slide.
export default function lib2Track(libraryItem, options) {

  const {startTime = 0, endTime = 2} = options

  const isCharacter = isCharacterItem(libraryItem) || isFyberItem(libraryItem)

  return {
    id: uuid(),
    enterEffect: {
      effectId: libraryItem.enterEffect || (isCharacter ? ENTER_EFFECT_IDS.SLIDE_FROM_LEFT : ENTER_EFFECT_IDS.FADE_IN),
      handContentId: null
    },
    exitEffect: {
      effectId: libraryItem.exitEffect || (isCharacter ? EXIT_EFFECT_IDS.SLIDE_TO_LEFT : EXIT_EFFECT_IDS.FADE_OUT),
      handContentId: null
    },
    startTime,
    endTime,
    sprites: [lib2docItem(libraryItem, options)]
  }
}
